"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _StyledIcon = _interopRequireWildcard(require("./StyledIcon"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _ykbIcons = require("ykb-icons");
var _excluded = ["name", "size", "color", "className", "children", "style", "colorType"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Icon = /*#__PURE__*/function (_PureComponent) {
  function Icon() {
    (0, _classCallCheck2.default)(this, Icon);
    return _callSuper(this, Icon, arguments);
  }
  (0, _inherits2.default)(Icon, _PureComponent);
  return (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        size = _this$props.size,
        color = _this$props.color,
        className = _this$props.className,
        children = _this$props.children,
        style = _this$props.style,
        colorType = _this$props.colorType,
        rest = (0, _objectWithoutProperties2.default)(_this$props, _excluded);
      var cls = (0, _classnames2.default)(className, (0, _defineProperty2.default)({}, "".concat(colorType, "-color"), !!colorType));
      var styleConfig = {};
      if (size && !isNaN(parseInt(size, 10))) {
        styleConfig['fontSize'] = parseInt(size, 10);
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        return /*#__PURE__*/_react.default.createElement(_StyledIcon.default, (0, _extends3.default)({
          className: cls
        }, rest, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)({
          $theme: theme,
          size: Icon.SIZES[size] ? undefined : size,
          $size: Icon.SIZES[size] && size,
          style: style
        }, "style", _objectSpread(_objectSpread(_objectSpread({}, styleConfig), style), {}, {
          color: color
        })), "color", color), "colorType", colorType)), /*#__PURE__*/_react.default.createElement(_StyledIcon.Svg, {
          name: name,
          children: children,
          $theme: theme
        }));
      });
    }
  }]);
}(_react.PureComponent);
(0, _defineProperty2.default)(Icon, "iconList", _ykbIcons.iconList);
(0, _defineProperty2.default)(Icon, "SIZES", {
  xsmall: true,
  small: true,
  medium: true,
  large: true
});
Icon.propTypes = {
  name: _propTypes.default.string,
  size: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xsmall', 'small', 'medium', 'large']), _propTypes.default.number, _propTypes.default.string]),
  color: _propTypes.default.string,
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  colorType: _propTypes.default.oneOf(['primary', 'secondary', 'default', 'success', 'warning', 'danger']),
  style: _propTypes.default.object
};
Icon.defaultProps = {
  className: ''
};
Icon.iconList = _ykbIcons.iconList;
var _default = exports.default = Icon;